import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ManageAdsComponent } from './components/manage-ads/manage-ads.component';
import { FormsModule } from '@angular/forms';
import { JobBoosterComponent } from './components/job-booster/job-booster.component';
import { SeoComponent } from './components/seo/seo.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ManageDocumentsComponent } from './components/manage-documents/manage-documents.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ManageUserComponent } from './components/manage-user/manage-user.component';
import { ManagePaymentsComponent } from './components/manage-payments/manage-payments.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { InstagramComponent } from './components/instagram/instagram.component';
import { ManageSeekerComponent } from './components/manage-seeker/manage-seeker.component';
import { ManageContentComponent } from './components/manage-content/manage-content.component';
import { ManageAgentComponent } from './components/manage-agent/manage-agent.component';
import { ManageJobPackageComponent } from './components/manage-job-package/manage-job-package.component';
import { JobImageComponent } from './components/job-image/job-image.component';
import { JobImageTemplateComponent } from './components/job-image-template/job-image-template.component';
import { TelegramComponent } from './components/telegram/telegram.component';
import { IndexComponent } from './components/index/index.component';
import { JobSourceLastComponent } from '../monitoring/components/job-source-last/job-source-last.component';
import { ManageSkillComponent } from './components/manage-skill/manage-skill.component';
import { ManageDiscountComponent } from './components/manage-discount/manage-discount.component';
import { RefineComponent } from './components/refine/refine.component';
import { VerifyAdsComponent } from './components/verify-ads/verify-ads.component';
import { SettingComponent } from './components/setting/setting.component';
import { AnnotationComponent } from './components/annotation/annotation.component';
import { ManageJobtitlesComponent } from './components/manage-jobtitles/manage-jobtitles.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SeekerModule } from '../seeker/seeker.module';
import { StatsDashboardComponent } from './components/stats-dashboard/stats-dashboard.component';
import { NpsReportComponent } from './components/nps-report/nps-report.component';
import { SharedPanelModule } from '../shared-panel/shared-panel.module';
import { KpiDashboardComponent } from './components/kpi-dashboard/kpi-dashboard.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ManageServiceRequestComponent } from './components/manage-service-request/manage-service-request.component';
import { OrganizationComponent } from './components/organization/organization.component';
import { InsightsComponent } from './components/insights/insights.component';
import { ManageJobAdvertiseComponent } from './components/manage-job-advertise/manage-job-advertise.component';
import { ManageNotificationsComponent } from './components/manage-notifications/manage-notifications.component';
import { SupportSettingsComponent } from './components/support-settings/support-settings.component';
import { AccountingComponent } from './components/accounting/accounting.component';
import { CommunicationModule } from '../communication/communication.module';
import { ManageResourceComponent } from './components/manage-resource/manage-resource.component';
import { WebModule } from '../web/web.module';
import { ManageAssessmentTestComponent } from './components/manage-assessment-test/manage-assessment-test.component';
import { ResourceModule } from '../resource/resource.module';
import { EditResourceComponent } from './components/edit-resource/edit-resource.component';
import { RtwadAdminListComponent } from './components/rtwad-admin-list/rtwad-admin-list.component';
import { CoreModule } from 'src/app/core/core.module';

@NgModule({
  declarations: [ManageAdsComponent, JobBoosterComponent, SeoComponent, ManageDocumentsComponent,
    ManageUserComponent, ManagePaymentsComponent, InstagramComponent, ManageSeekerComponent, ManageContentComponent,
    ManageAgentComponent, ManageJobPackageComponent, JobImageComponent, JobImageTemplateComponent, TelegramComponent,
    IndexComponent, JobSourceLastComponent, ManageSkillComponent, ManageDiscountComponent, RefineComponent,
    VerifyAdsComponent, SettingComponent, AnnotationComponent, ManageJobtitlesComponent,
    StatsDashboardComponent, NpsReportComponent, KpiDashboardComponent, ManageServiceRequestComponent,
    OrganizationComponent, InsightsComponent, ManageJobAdvertiseComponent, ManageNotificationsComponent, 
    SupportSettingsComponent, AccountingComponent, ManageResourceComponent, ManageAssessmentTestComponent, EditResourceComponent, RtwadAdminListComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    CoreModule,
    SharedModule,
    SharedPanelModule,
    SeekerModule,
    AngularEditorModule,
    NgxSmartModalModule,
    NgSelectModule,
    ScrollingModule,
    HighchartsChartModule,
    CommunicationModule,
    WebModule,
    ResourceModule
  ],
  exports: [ManageJobtitlesComponent]
})
export class AdminModule { }
